import React from 'react';

export default function LoadingRectangle() {
  return (
    <div className="sk-spinner sk-spinner-wave" data-testid="react-loader">
      <div className="sk-rect1" />
      <div className="sk-rect2 mx-1" />
      <div className="sk-rect3" />
      <div className="sk-rect4 mx-1" />
      <div className="sk-rect5" />
    </div>
  );
}